<ng-container *transloco="let t">
  <div class="relative flex flex-col gap-4 pt-4">
    <app-select-accounts-page
      [preselectedAccountsMarketplaces]="selectedAccountMarketplaces()"
      [accountMarketplaces]="availableAccountMarketplaces()"
      [orgId]="selectedOrganization().id"
      (selectionChange)="selectionChange($event)"
    />
    <div class="sticky bottom-0 flex justify-end gap-x-2 border-t bg-white py-4">
      <button iButton variant="secondary" size="md" (click)="cancelSelection()">{{ t("common.cancel") }}</button>
      <button iButton size="md" (click)="confirmSelection()" [disabled]="selectedAccountMarketplaces().length === 0">
        {{ isUpdating ? t("common.update") : t("common.create") }}
      </button>
    </div>
  </div>
</ng-container>
